import React, {Component} from 'react';
import {observer} from 'mobx-react';
import SensorStore from './request/model';
import TemperatureCom from './temperature';
import DistanceCom from './distance';
import './index.styl';

import {
    Tabs
} from 'antd';

const {
    TabPane
} = Tabs;

const clzpre = 'ssfe-sensor';

@observer
class Sensor extends Component{
    constructor(props){
        super(props);
        this.state = {
            activeKey: 'temperature'
        }
    }

    render(){
        const {activeKey} = this.state;
        return (
            <div className={`${clzpre} com-bg`}>
                <Tabs
                    tabPosition={'left'}
                    activeKey={activeKey}
                    onChange={(key) => {
                        this.setState({
                            activeKey: key
                        });
                    }}
                >
                    <TabPane tab={'温湿度'} key={'temperature'}>
                        {activeKey === 'temperature' && <TemperatureCom {...this.props} />}
                    </TabPane>
                    <TabPane tab={'测距'} key={'distance'}>
                        {activeKey === 'distance' && <DistanceCom {...this.props} />}
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}

export default (props) => <Sensor {...props} SensorStore={SensorStore} />;
